<canvas #chart height="380"></canvas>